import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Reads the owner-edited weekly schedule. Refreshes on the
// `ool:schedule-changed` window event for instant updates.
export const useSchedule = () => {
    const [days, setDays] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchIt = async () => {
        try {
            const { data } = await axios.get(`${API}/schedule`, { timeout: 6000 });
            setDays(data?.days || []);
        } catch {
            setDays([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchIt();
        const onChange = () => fetchIt();
        window.addEventListener("ool:schedule-changed", onChange);
        return () => window.removeEventListener("ool:schedule-changed", onChange);
    }, []);

    return { days, loading, refetch: fetchIt };
};
